function autofill(){


  
  
var organization = document.getElementById('organization').value; 
document.getElementById('organization_shipping').value=organization;
  
  var firstname = document.getElementById('first-name').value; 
document.getElementById('first-name_shipping').value=firstname;
  
  var lastname = document.getElementById('last-name').value; 
document.getElementById('last-name_shipping').value=lastname;
      
  var city = document.getElementById('city').value; 
document.getElementById('city_shipping').value=city;
  
  var address1 = document.getElementById('address1').value; 
document.getElementById('address1_shipping').value=address1;
  
  var address2 = document.getElementById('address2').value; 
document.getElementById('address2_shipping').value=address2;

  
   var postal = document.getElementById('postal').value; 
document.getElementById('postal_shipping').value=postal;   
  
 
var country = document.getElementById('country').value; 
document.getElementById('country_shipping').value=country;
  
   var position = document.getElementById('position').value; 
document.getElementById('position_shipping').value=position;    

    
var province = document.getElementById('province').value;
  
ajax_province_shipping(country,province); 
  
  
//alert(province);
  
//document.getElementById('province_shipping').value=province;
    
//alert( document.getElementById('province_shipping').value);  
    
    

  
  
  
  

  
  

  
  
}